import {
    PlaydateInvite,
} from "gql/types";
import { TagVariant } from "../InfoTag";
import { inviteStatusTagComputer } from "../inviteStatusTagComputer";
import { recipientResponseTagComputer } from "../recipientResponseTagComputer";
import { inboundTopLeftLabelComputer } from "../inboundTopLeftLabelComputer";
import { resolveRSVPTags } from "../rsvpTagResolver";

interface InfoTag {
    label: string;
    variant: TagVariant;
}

const TAG_PRIORITY_ORDER = [
    "Finalized",
    "Cancelled",
    "Expired",
    "Pending",
    "Attending",
    "Availability Shared",
    "Can't Make It",
    "Provide Your Availability",
    "Details Changed",
    "RSVP Due Soon",
];

export function inboundTagsResolver(invite: PlaydateInvite): InfoTag[] {
    const statusTags = inviteStatusTagComputer(invite);
    const responseTags = recipientResponseTagComputer(invite);
    const topLeftTags = inboundTopLeftLabelComputer(invite);
    const rsvpTags = resolveRSVPTags(invite);

    const allTags = [
        ...statusTags,
        ...responseTags,
        ...topLeftTags,
        ...rsvpTags,
    ];

    // Short-circuit if Cancelled or Expired is already in the output
    if (allTags.some(tag => tag.label === "Cancelled" || tag.label === "Expired")) {
        return statusTags;
    }

    if (invite.expired) {
        return statusTags;
    }

    const tagMap = new Map<string, InfoTag>();
    for (const tag of allTags) {
        tagMap.set(tag.label, tag);
    }

    const hasNoResponse = responseTags.some(tag =>
        tag.label === "Provide Your Availability"
    );

    if (!hasNoResponse) {
        tagMap.delete("RSVP Due Soon");
    }


    return Array.from(tagMap.values()).sort((a, b) => {
        const aIndex = TAG_PRIORITY_ORDER.indexOf(a.label);
        const bIndex = TAG_PRIORITY_ORDER.indexOf(b.label);
        return (aIndex === -1 ? 999 : aIndex) - (bIndex === -1 ? 999 : bIndex);
    });
}
